import React from "react";

// Clean, minimal pricing — big prices as the focal point on a soft accent
// panel. One accent per competition keeps each page on-brand.
const themes = {
  primary: {
    label: "text-arsen-primary-600",
    panel: "bg-arsen-primary-50",
    divide: "divide-arsen-primary-100",
    price: "text-arsen-primary-600",
    underline: "bg-arsen-primary-400",
    chip: "bg-arsen-primary-600",
    dot: "bg-arsen-primary-400",
  },
  secondary: {
    label: "text-arsen-secondary-600",
    panel: "bg-arsen-secondary-50",
    divide: "divide-arsen-secondary-100",
    price: "text-arsen-secondary-600",
    underline: "bg-arsen-secondary-400",
    chip: "bg-arsen-secondary-600",
    dot: "bg-arsen-secondary-400",
  },
  tertiary: {
    label: "text-arsen-tertiary-600",
    panel: "bg-arsen-tertiary-50",
    divide: "divide-arsen-tertiary-100",
    price: "text-arsen-tertiary-600",
    underline: "bg-arsen-tertiary-400",
    chip: "bg-arsen-tertiary-600",
    dot: "bg-arsen-tertiary-400",
  },
};

function formatIDR(amount) {
  return amount.toLocaleString("id-ID");
}

export default function Pricing({ color = "primary", batches, note }) {
  const theme = themes[color] || themes.primary;
  const cheapest = Math.min(...batches.map((b) => b.price));

  return (
    <div data-aos="zoom-in" className="flex flex-col gap-4">
      <div className={`overflow-hidden rounded-2xl ${theme.panel}`}>
        <div className="px-6 pt-7 pb-1 sm:px-10">
          <span
            className={`text-xs font-semibold uppercase tracking-[0.2em] ${theme.label}`}
          >
            Biaya Pendaftaran
          </span>
        </div>

        <div
          className={`flex flex-col divide-y sm:flex-row sm:divide-x sm:divide-y-0 ${theme.divide}`}
        >
          {batches.map((batch, index) => {
            const isBest = batch.price === cheapest;

            return (
              <div key={index} className="flex-1 px-6 py-7 sm:px-10">
                <div className="flex items-center gap-3">
                  <span className="text-xs font-semibold uppercase tracking-[0.15em] text-gray-500">
                    {batch.name}
                  </span>
                  {isBest && (
                    <span
                      className={`rounded-full px-2.5 py-1 text-[10px] font-bold uppercase tracking-[0.12em] text-white ${theme.chip}`}
                    >
                      Termurah
                    </span>
                  )}
                </div>

                <div className="mt-4 flex items-baseline gap-1.5">
                  <span className="text-xl font-bold text-gray-400">Rp</span>
                  <span
                    className={`text-5xl font-extrabold tracking-tight ${
                      isBest ? theme.price : "text-arsen-quaternary"
                    }`}
                  >
                    {formatIDR(batch.price)}
                  </span>
                  <span className="ml-1 text-sm font-medium text-gray-400">
                    / tim
                  </span>
                </div>

                <span
                  className={`mt-5 block h-1 w-12 rounded-full ${
                    isBest ? theme.underline : "bg-gray-300"
                  }`}
                />

                {batch.period && (
                  <div className="mt-4 text-sm text-gray-500">
                    {batch.period}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>

      {note && (
        <div className="flex items-start gap-2.5 px-1 text-sm text-gray-600">
          <span
            className={`mt-1.5 h-1.5 w-1.5 flex-none rounded-full ${theme.dot}`}
          />
          <span>{note}</span>
        </div>
      )}
    </div>
  );
}
